import React from "react";
import { bool } from "prop-types";

import OndemandVideoRoundedIcon from "@mui/icons-material/OndemandVideoRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";

import BaseMenu from "./BaseMenu";
import VideoSettingsRoundedIcon from "shared/chrome/menus/icons/VideoSettingsRoundedIcon";

const ResourcesMenu = ({ useRouterNavigation = true }) => {
  return (
    <BaseMenu
      menuTitle="Resources"
      MenuIcon={OndemandVideoRoundedIcon}
      useRouterNavigation={useRouterNavigation}
      items={[
        {
          text: "Webinars",
          icon: <OndemandVideoRoundedIcon />,
          href: "/webinars",
          googleAnalyticsLabel: "Resources: Webinars",
        },
        {
          text: "Demo videos",
          icon: <VideoSettingsRoundedIcon />,
          href: "/videos",
          googleAnalyticsLabel: "Resources: Videos",
        },
        {
          text: "Documents",
          icon: <DescriptionRoundedIcon />,
          href: "/documents",
          googleAnalyticsLabel: "Resources: Documents",
        },
      ]}
    />
  );
};

ResourcesMenu.propTypes = {
  useRouterNavigation: bool,
};

export default ResourcesMenu;
